import {getDmsUrl} from "@ekultur/dms-url-generator";
import {createUseStyles} from "react-jss";
import React from "react";

const useStyles = createUseStyles(() => ({
    media: {
        flexGrow: 1,
        minHeight: 0,
        maxHeight: "360px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    image: {
        objectFit: "contain",
        width: "100%",
        maxHeight: "360px",
        height: "auto",
    }
}));

export const QuestionMedia = ({media}) => {
    const classes = useStyles();

    if(media) {
        return (
            <div className={classes.media}>
                <img
                    src={getDmsUrl(media.dmsId)}
                    alt={media.alt || ""}
                    className={classes.image}
                />
            </div>
        );
    } else {
        return null;
    }
};
